export const FETCH_START        = "NewsList/FETCH_START"
export const FETCH_SUCCESS      = "NewsList/FETCH_SUCCESS"
export const FETCH_FAILED       = "NewsList/FETCH_FAILED"
